import { AccountStatusDatastore } from '../datastore/account_status_datastore';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';
import * as _4 from 'lodash4';
const LoginConfigModelDTD = {
  auth_type: {
    type: 'enum',
    typeDef: 'AuthTypeEnum',
    defaultValue: 'NATIVE'
  },
  login_footer_url: 'string',
  login_header_url: 'string',
  login_url: 'string',
  logout_url: 'string',
  theme_primary_color: 'string',
  inst_name: 'string',
  hello_completed: {
    optional: true,
    type: 'tri-state',
    writeToKey: 'helloCompleted',
    defaultValue: false
  },
  render_type: {
    type: 'enum',
    typeDef: 'RenderTypeEnum',
    defaultValue: 'BUTTON_ONLY_LOGIN'
  },
  institution_media_paths: 'object',
  section_label: 'string',
  intro_accepted: 'boolean',
  tandc_accepted: 'boolean',
  tandc_text: 'html',
  user_id_label: {
    type: 'string',
    defaultValue: 'Enter your User ID',
    writeToKey: 'userIdLabel'
  },
  login_config_message: 'string'
};

export class LoginConfigModel {
  private login_url: string;
  constructor(
    private Interface: any,
    private ngMemberConfigurationDatastore: MemberConfigurationDatastore,
    private ngAccountStatusDatastore: AccountStatusDatastore
  ) {}
  clear() {
    this.ngMemberConfigurationDatastore.initialize();
    this.ngAccountStatusDatastore.initialize();
    return this.synchronize();
  }
  initialize() {
    this.clear();
  }
  update(data: any) {
    this.ngMemberConfigurationDatastore.update(data);
    this.ngAccountStatusDatastore.update(data);
    return this.synchronize();
  }

  isValid() {
    return !_4.isEmpty(this.login_url);
  }

  synchronize() {
    const o = _4.merge(
      {},
      this.ngMemberConfigurationDatastore.read((store) => store),
      this.ngAccountStatusDatastore.read((store) => store)
    );
    this.Interface.implement(LoginConfigModelDTD, o, this);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/models/login_config_model.ts